module.exports = __webpack_public_path__ + "img/layout-2.20fb7163.svg";